<script setup>
import { formatearMoneda as formatear, parsearMoneda as parsear } from "@/utils/formatoMoneda"

defineProps({
  titulo: { type: String, required: true },
  hoteles: { type: Array, required: true },
  labelValor: { type: String, default: "Valor Total Comisionable" },
  moneda: { type: String, default: "COP" }
})

const emit = defineEmits(["agregar", "eliminar"])
</script>

<template>
  <div class="card mb-3">
    <div class="card-header d-flex justify-content-between align-items-center">
      <strong>{{ titulo }}</strong>
      <button type="button" class="btn btn-sm btn-outline-primary" @click="emit('agregar')">
        <i class="bi bi-plus-lg"></i> Hotel
      </button>
    </div>

    <div class="card-body">
      <div v-for="(hotel, i) in hoteles" :key="i" class="row g-2 align-items-end mb-2">
        <div class="col-md-6">
          <label class="form-label small mb-0">Hotel {{ i + 1 }}</label>
          <input type="text" class="form-control" v-model="hotel.nombre" placeholder="Nombre del hotel">
        </div>

        <div class="col-md-5">
          <label class="form-label small mb-0">{{ labelValor }}</label>
          <div class="input-group">
            <span class="input-group-text">{{ moneda }}</span>
            <input
              type="text"
              class="form-control"
              :value="formatear(hotel.valor)"
              @input="hotel.valor = parsear($event.target.value)"
              placeholder="0"
            >
          </div>
        </div>

        <div class="col-md-1">
          <button
            type="button"
            class="btn btn-outline-danger w-100"
            :disabled="hoteles.length <= 1"
            @click="emit('eliminar', i)"
          >
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
